import React from 'react'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'

interface DetailProps {
  listEl: any
  listStatus: string
  userList: any
  mode?: string
}

export const AssetTransferByDepartmentDetailContent = (props: DetailProps) => {
  const { listEl, listStatus, userList, mode } = props

  const getDepartmentDisplay = (department: any) => {
    if (!department) return '-'
    if (department.Code && department.Name) {
      return `${department.Code} - ${department.Name}`
    }
    return department.Name || '-'
  }

  const getLocationDisplay = (location: any) => {
    if (!location) return '-'
    return location.description
      ? `${location.name} - ${location.description}`
      : location.name
  }

  return (
    <>
      <div className="content-wrap left full">
        <div className="desc" style={{ color: 'grey' }}>
          {'Asset Name'}
        </div>
        <div className="mdDesc text-noflow">{listEl?.Asset?.name || '-'}</div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Asset No'}
        </div>
        <div className="mdDesc text-noflow">{listEl?.Asset?.DocNo || '-'}</div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'Model No'}
        </div>
        <div className="mdDesc text-noflow">
          {listEl?.Asset?.model_no || '-'}
        </div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Transfer Date'}
        </div>
        <div className="mdDesc text-noflow">
          {listEl?.transfer_date ? formatDate(listEl.transfer_date) : '-'}
        </div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'Transfer Quantity'}
        </div>
        <div className="mdDesc text-noflow">{listEl?.transfer_qty || 0}</div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'From Department'}
        </div>
        <div className="mdDesc text-noflow">
          {getDepartmentDisplay(listEl?.FromDepartment)}
        </div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'To Department'}
        </div>
        <div className="mdDesc text-noflow">
          {getDepartmentDisplay(listEl?.ToDepartment)}
        </div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'From Location'}
        </div>
        <div className="mdDesc text-noflow">
          {getLocationDisplay(listEl?.FromLocation)}
        </div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'To Location'}
        </div>
        <div className="mdDesc text-noflow">
          {getLocationDisplay(listEl?.ToLocation)}
        </div>
      </div>

      <div className="content-wrap left full">
        <div className="desc" style={{ color: 'grey' }}>
          {'Description'}
        </div>
        <div className="mdDesc text-noflow">{listEl?.description || '-'}</div>
      </div>

      <div className="content-wrap left full">
        <div className="desc" style={{ color: 'grey' }}>
          {'Reason'}
        </div>
        <div className="mdDesc text-noflow">{listEl?.reason || '-'}</div>
      </div>

      {listEl?.submittedBy && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              {'Submitted By'}
            </div>
            <div className="mdDesc text-noflow">
              {userList?.filter(user => user.ID == listEl?.submittedBy)[0]
                ?.name || 'N/A'}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              {'Submitted Date'}
            </div>
            <div className="mdDesc text-noflow">
              {listEl?.submittedTs ? formatDate(listEl.submittedTs) : '-'}
            </div>
          </div>
        </>
      )}

      {listStatus === 'COMPLETED' && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              {'Approved Date'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {formatDate(listEl?.approvedTs)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              {'Approved By'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {userList?.filter(user => user.ID == listEl?.approvedBy)[0]
                ?.name || 'N/A'}
            </div>
          </div>
        </>
      )}

      {listStatus === 'REJECTED' && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              {'Rejection Date'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {formatDate(listEl?.RejectionDate)}
            </div>
          </div>
          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              {'Rejection Remark'}
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {listEl?.RejectionRemark || 'N/A'}
            </div>
          </div>
        </>
      )}
    </>
  )
}
